// Profile access is administrator-owned. Keep browser payloads and server
// authorization on the same explicit self-service field list.
export const SELF_PROFILE_FIELDS = [
  'fullName', 'email', 'personalEmail', 'personalPhone', 'homeAddress',
  'birthDate', 'maritalStatus', 'spouseName', 'numberOfChildren',
  'childrenNames', 'emergencyContact', 'professionalGoals', 'notes',
  'password',
] as const;

export function isSelfProfileField(field: string): boolean {
  return (SELF_PROFILE_FIELDS as readonly string[]).includes(field);
}

export function selfProfilePayload(values: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(Object.entries(values).filter(([field]) => isSelfProfileField(field)));
}

export function omitUnchangedLoginEmail(values: Record<string, unknown>, currentEmail: unknown): Record<string, unknown> {
  const payload = { ...values };
  if (typeof payload.email === 'string' && typeof currentEmail === 'string' &&
      payload.email.trim().toLowerCase() === currentEmail.trim().toLowerCase()) {
    delete payload.email;
  }
  return payload;
}

export function mayPatchProfile(
  actor: { id?: string; isSuperAdmin?: boolean } | undefined,
  targetId: string,
  payload: Record<string, unknown>,
): boolean {
  if (actor?.isSuperAdmin === true) return true;
  return Boolean(actor?.id && actor.id === targetId && Object.keys(payload).every(isSelfProfileField));
}
